import templateUrl from "webforms/formio/formio-list.htm";

export default () => ({
  templateUrl
});
